import { Global, ThemeProvider } from '@emotion/react'
import { Theme } from './styles/settings/theme'
import { GlobalStyles } from './styles/global'
import './App.css'
import Main from './components/pages/Main'

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <Global styles={GlobalStyles} />
      <Main />
    </ThemeProvider>
  )
}

export default App
